<template>
  <div class="cost-efficient">
    <div class="cost-efficient__bg" :style="{ backgroundImage: `url('${image}')`}">
      <div class="cost-efficient__bg-video-wrapper">
        <video
          class="cost-efficient__bg-video"
          :src="bgVideo"
          muted
          plays-inline
          autoplay
          loop
        ></video>
      </div>
    </div>
    <div class="cost-efficient__innerwrap">
      <div class="cost-efficient__content-wrap">
        <h1 class="cost-efficient__title" v-html="benefit.title"></h1>
        <div class="cost-efficient__content">
          <ul>
            <li v-for="(item, index) in benefit.list" :key="index" v-html="item"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CostEfficient',
  props: ['benefit'],
  computed: {
    image() {
      return `static/${this.benefit.image}`;
    },
    bgVideo() {
      return `static/${this.benefit.bg_video}`;
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/helpers';

.cost-efficient {
  @include section;

  &__bg {
    left: 56%;
    right: 0;
    bottom: 0;
    top: 0;
    background-size: cover;
    background-position: center;
    display: block;
    position: absolute;
    overflow: hidden;
  }

  &__bg-video-wrapper {
    @include aspect-ratio-box-cover(450/708, $menubar-height, 45vw);
    // z-index: -1;
  }

  &__bg-video {
    width: 100%;
    height: 100%;
    display: block;
  }

  &__content-wrap {
    width: calc(6/12 * 100% + 50px);
  }

  &__title {
    @include font-heading;

    em {
      font: inherit;
      display: inline-block;
      position: relative;

      &::before {
        content: '';
        display: block;
        width: 238px;
        height: 14px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('../../assets/cost-efficient_underscore.svg');
        position: absolute;
        top: calc(100% - .1em);
        left: -30px;
      }
    }
  }

  &__content {
    @include font-content;
    margin-right: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/CostEfficient.vue